import CreationUtilisateurRow from "./CreationUtilisateurRow";
import ModificationUtilisateurRow from "./ModificationUtilisateurRow";
import LoginUtilisateurRow from "./LoginUtilisateurRow";
import MotPasseUtilisateurRow from "./MotPasseUtilisateurRow";
import ChangementMailDialog from "./ChangementMailDialog";
import AssociationDashboardCard from "./AssociationDashboardCard";
import RequeteDashboardCard from "./RequeteDashboardCard";
import ChangementMotPasseDialog from "./ChangementMotPasseDialog";
import ActionPossibleRegistreCard from "./ActionPossibleRegistreCard";

export default {
    install(Vue) {
        Vue.component("a-creation-utilisateur-row", CreationUtilisateurRow);
        Vue.component("a-modification-utilisateur-row", ModificationUtilisateurRow);
        Vue.component("a-login-utilisateur-row", LoginUtilisateurRow);
        Vue.component("a-motpasse-utilisateur-row", MotPasseUtilisateurRow);
        Vue.component("a-changement-mail-dialog", ChangementMailDialog);
        Vue.component("a-association-dashboard-card", AssociationDashboardCard);
        Vue.component("a-requete-dashboard-card", RequeteDashboardCard);
        Vue.component("a-action-possible-registre-card", ActionPossibleRegistreCard);
        Vue.component("a-changement-mot-passe-dialog", ChangementMotPasseDialog);
    }
}
